import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useAuth } from "react-oidc-context";

function NavTop() {
    console.log("Rendering NavTop...");
    const auth = useAuth();

    const handleLogout = (e) => {
        e.preventDefault();
        
        const clientId = "6025mbahv0jiru600106dqoues";
        const logoutUri = import.meta.env.VITE_LOGOUT_URI || "http://localhost:3000/logged-out";
        const cognitoDomain = "https://auth.lostlogic.io";
        
        // Set logout flag
        sessionStorage.setItem('isLoggingOut', 'true');
        
        // Clear all local data
        localStorage.clear();
        
        // Remove user from oidc-context
        auth.removeUser().then(() => {
            // Redirect to Cognito logout
            window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
        });
    };

    return(
        <Navbar bg="light" expand="md" data-bs-theme="light" collapseOnSelect className="bg-body-tertiary">
            <Container>
                <Navbar.Brand href="#home">
                    <img 
                        style={{maxHeight: "25px", width: "auto"}} 
                        src="/img/logo/lost-logic-high-resolution-logo-transparent.png"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <Nav className="me-auto">
                    <Nav.Link href="/user-management">Manage GSC Users</Nav.Link>
                    <Nav.Link href="/reporting">Reporting</Nav.Link>
                    <Nav.Link href="/host-monitoring">Host Monitoring</Nav.Link>
                    <Nav.Link href="/profile">
                        <i className="fa-solid nav-icon fa-user-ninja"></i>
                    </Nav.Link>
                    <Nav.Link onClick={handleLogout} style={{ cursor: 'pointer' }}>
                        <i className="fa-solid nav-icon fa-person-through-window"></i>
                    </Nav.Link>
                </Nav>
            </Container>
        </Navbar>
    );
}

export default NavTop;